import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  FaConciergeBell,
  FaMoneyBillAlt,
  FaSearch,
  FaFilter,
  FaChevronDown,
  FaChevronUp,
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
const BQ_BASE_URL = process.env.REACT_APP_BQ_BASE_URL;

function Amenities() {
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedService, setSelectedService] = useState('');
  const [expandedService, setExpandedService] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [categoriesRes, servicesRes, itemsRes] = await Promise.all([
          axios.get(`${BQ_BASE_URL}/bq/api/amenitycategories/`),
          axios.get(`${BQ_BASE_URL}/bq/api/amenityservices/`),
          axios.get(`${BQ_BASE_URL}/bq/api/amenityitems/`),
        ]);

        setCategories(categoriesRes.data);
        setServices(servicesRes.data);
        setItems(itemsRes.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
        toast.error('Failed to fetch amenities data');
      }
    };

    fetchData();
  }, []);

  const toggleService = (serviceId) => {
    if (expandedService === serviceId) {
      setExpandedService(null);
    } else {
      setExpandedService(serviceId);
    }
  };

  const filteredServices = services.filter((service) => {
    const matchesCategory = selectedCategory
      ? service.categoryid === parseInt(selectedCategory)
      : true;
    const matchesSearch = service.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const filteredItems = items.filter((item) => {
    const matchesService = selectedService ? item.serviceid === parseInt(selectedService) : true;
    return matchesService;
  });

  const getCategoryName = (id) => {
    const category = categories.find((c) => c.id === id);
    return category ? category.name : 'Unknown Category';
  };

  if (loading) return <div className="p-6">Loading...</div>;
  if (error) return <div className="p-6 text-red-500">Error: {error}</div>;

  return (
    <div className="bg-gray-100 p-6 relative min-h-screen">
      {/* <div className="w-1/4 bg-gray-100 text-black p-4 text-base font-semibold">
        <ul className="space-y-4 mt-4">
          <li className="hover:bg-gray-200 p-2 rounded flex items-center space-x-2">
            <FaConciergeBell className="text-lg" />
            <Link to="/dashboard/mdm/amenities-management/room-service">
              Room Service
            </Link>
          </li>
          <li className="bg-black text-white p-2 rounded flex items-center space-x-2">
            <FaMoneyBillAlt className="text-lg" />
            <Link to="/dashboard/mdm/amenities-management/amenities">
              Amenities
            </Link>
          </li>
        </ul>
      </div> */}

      <header className="flex justify-between items-center mb-3 bg-white p-3">
        <h1 className="text-black text-xl font-bold ml-2">Amenities Management</h1>
        <div className="flex space-x-6">
          <button
            onClick={() => navigate('/dashboard/mdm/amenities-management/room-service')}
            className="btn"
          >
            Room Service
          </button>
          <button
            onClick={() => navigate('/dashboard/mdm/amenities-management/amenities')}
            className="btn text-black font-bold"
          >
            Amenities
          </button>
        </div>
      </header>

      <div className="ml-1 p-6 w-full bg-white">
        <h1 className="text-xl font-bold">Amenities</h1>
        <p className="text-sm">
          Manage your hotel amenities such as meals, housekeeping, paid amenities, and room service
          requests here.
        </p>

        {/* Filters and Search */}
        <div className="mt-6 bg-gray-50 p-4 rounded-lg shadow-sm">
          <div className="flex flex-wrap items-center gap-4">
            <div className="relative flex-1 min-w-[200px]">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FaSearch className="text-gray-400" />
              </div>
              <input
                type="text"
                placeholder="Search services..."
                className="pl-10 pr-4 py-2 w-full border rounded-lg "
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="flex items-center gap-2 bg-white px-3 py-2 rounded-lg border">
              <FaFilter className="text-gray-400" />
              <select
                className="bg-transparent outline-none"
                value={selectedCategory}
                onChange={(e) => {
                  setSelectedCategory(e.target.value);
                  setSelectedService('');
                }}
              >
                <option value="">All Categories</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>

            <Link to={'/dashboard/mdm/amenities-management/amenities/manage-amenity-category'}>
              <div className="mt-2 flex justify-end">
                <button className="px-10 py-2 bg-black text-white hover:text-white rounded">
                  Manage Amenities Services
                </button>
              </div>
            </Link>

            {/* <div className="flex items-center gap-2 bg-white px-3 py-2 rounded-lg border">
              <FaFilter className="text-gray-400" />
              <select
                className="bg-transparent border-none focus:ring-0"
                value={selectedService}
                onChange={(e) => setSelectedService(e.target.value)}
                disabled={!selectedCategory}
              >
                <option value="">All Services</option>
                {services
                  .filter(service => service.categoryid === parseInt(selectedCategory))
                  .map(service => (
                    <option key={service.id} value={service.id}>
                      {service.name}
                    </option>
                  ))}
              </select>
            </div> */}
          </div>
        </div>

        {/* Services Table */}
        <div className="mt-6 overflow-x-auto rounded-lg border shadow-sm">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Service Name
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Category
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Duration
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Status
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Items
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredServices.map((service) => {
                const serviceItems = filteredItems.filter((item) => item.serviceid === service.id);
                return (
                  <React.Fragment key={service.id}>
                    <tr
                      className="hover:bg-gray-50 cursor-pointer"
                      onClick={() => toggleService(service.id)}
                    >
                      <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">
                        {service.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-gray-500">
                        {getCategoryName(service.categoryid)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-gray-500">
                        {service.duration} {service.duration === 1 ? 'day' : 'days'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span
                          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                          ${
                            service.isavailable
                              ? 'bg-gray-100 text-gray-800'
                              : 'bg-red-100 text-red-800'
                          }`}
                        >
                          {service.isavailable ? 'Available' : 'Unavailable'}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-gray-500">
                        <div className="flex items-center">
                          {serviceItems.length} items
                          {expandedService === service.id ? (
                            <FaChevronUp className="ml-2 text-gray-400" />
                          ) : (
                            <FaChevronDown className="ml-2 text-gray-400" />
                          )}
                        </div>
                      </td>
                    </tr>
                    {expandedService === service.id && serviceItems.length > 0 && (
                      <tr className="bg-gray-50">
                        <td colSpan="5" className="px-6 py-4">
                          <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                              <thead className="bg-gray-100">
                                <tr>
                                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Item Name
                                  </th>
                                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Base Price
                                  </th>
                                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Urgent Price
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-200">
                                {serviceItems.map((item) => (
                                  <tr key={item.id} className="hover:bg-gray-100">
                                    <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900">
                                      {item.name}
                                    </td>
                                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                                      ₹{item.baseprice}
                                    </td>
                                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                                      ₹{item.urgentprice}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
              {filteredServices.length === 0 && (
                <tr>
                  <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
                    No services found matching your criteria
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Toast Container */}
        <ToastContainer />
      </div>
    </div>
  );
}

export default Amenities;

// import { Link } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import {
//   FaConciergeBell,
//   FaMoneyBillAlt,
// } from "react-icons/fa";

// function Amenities() {
//   return (
//     <div className="flex h-screen">
//       <div className="w-1/4 bg-gray-100 text-black p-4 text-base font-semibold">
//         <ul className="space-y-4 mt-4">
//           <li className="hover:bg-gray-200 p-2 rounded flex items-center space-x-2">
//             <FaConciergeBell className="text-lg" />
//             <Link to="/dashboard/mdm/amenities-management/room-service">
//               Room Service
//             </Link>
//           </li>
//           <li className="bg-black text-white p-2 rounded flex items-center space-x-2">
//             <FaMoneyBillAlt className="text-lg" />
//             <Link to="/dashboard/mdm/amenities-management/amenities">
//               Amenities
//             </Link>
//           </li>
//         </ul>
//       </div>

//       <div className="ml-1 p-6 w-full bg-white">
//         <h1 className="text-xl font-bold">Amenities</h1>
//         <p className="text-sm">
//           Manage your hotel amenities such as meals, housekeeping, paid
//           amenities, and room service requests here.
//         </p>

//        <Link to={"/dashboard/mdm/amenities-management/amenities/manage-amenity-category"}>
//        <div className="mt-2 flex justify-end">
//           <button

//             className="px-10 py-2 bg-cyan-500 text-white hover:text-black rounded"
//           >
//             Manage Amenities Services
//           </button>
//         </div>
//        </Link>

//         {/* Toast Container */}
//         <ToastContainer />
//       </div>
//     </div>
//   );
// }

// export default Amenities;
